"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriveNamesHelper = void 0;
var url_1 = require("../utils/url");
var DriveNamesHelper = /** @class */ (function () {
    function DriveNamesHelper() {
    }
    DriveNamesHelper.buildContentName = function (md5, portalUserId, srv, nsid) {
        return "srv/".concat(srv ? srv : "upload", "/").concat(nsid ? "nsid/" + nsid + "/" : "", "uid/").concat(portalUserId, "/").concat(md5.toLowerCase());
    };
    DriveNamesHelper.buildContentUrlByName = function (driveApiUrl, contentName) {
        return (0, url_1.combineUrls)(driveApiUrl, (0, url_1.combineUrls)("contents", contentName));
    };
    DriveNamesHelper.buildContentNameByUrl = function (driveContentUrl) {
        var query = new URL(driveContentUrl).search;
        if (!!query) {
            var urlSearchParams = new URLSearchParams(query);
            var name_1 = urlSearchParams.get("name") || urlSearchParams.get("Name");
            if (!!name_1)
                return name_1;
        }
        return driveContentUrl.replace(/https?:\/\/.*contents\//gi, "");
    };
    DriveNamesHelper.getPortalUserIdFromUrl = function (driveUrl) {
        var segmentValue = DriveNamesHelper.getSegment("uid", driveUrl);
        return segmentValue;
    };
    DriveNamesHelper.getSegment = function (segmentName, driveUrl, toTheEnd) {
        driveUrl = driveUrl.toLowerCase();
        segmentName = segmentName.toLowerCase();
        var delimeter = segmentName + "/";
        var index = driveUrl.indexOf(delimeter);
        var value = driveUrl.substring(index + delimeter.length, driveUrl.length - index - delimeter.length);
        var indexOfSlash = value.indexOf("/");
        if (toTheEnd || indexOfSlash < 0)
            return value;
        value = value.substring(0, indexOfSlash);
        return value;
    };
    return DriveNamesHelper;
}());
exports.DriveNamesHelper = DriveNamesHelper;
